import { Pipe, PipeTransform } from '@angular/core';

import moment from 'moment-timezone';

@Pipe({
	name: 'auditReportFriendlyDateColumn',
	standalone: false,
})
export class AuditReportFriendlyDateColumnPipe implements PipeTransform {
	transform(date: string, isQuarters: boolean): string {
		if (!date) {
			return date;
		}
		return !isQuarters ? moment(date, 'MM/DD/YYYY').format('MMMM YYYY') : moment(date, 'MM/DD/YYYY').format('[Q]Q YYYY');
	}
}
